/** EMMIT events*/
export let emmit = (eventName, data) => {
  let payload = {
    detail: data
  };

  let customEvent = new CustomEvent(eventName, payload);

  window.dispatchEvent(customEvent);
};
